import React from 'react';
import Testimonials from '../components/Testimonials';

const TestimonialsPage = () => {
  return <Testimonials />;
};

export default TestimonialsPage;
